import { Button, Input, Typography } from '@/primer/components';
import { PageLayout } from '@/components/layout';

export interface AuthEmailFormProps {
  email: string;
  onEmailChange?: (value: string) => void;
  onSubmit: () => void;
  isReadOnly?: boolean;
  canContinue: boolean;
  isSubmitting: boolean;
  submitError?: string;
  helperText?: string;
  testIdPrefix?: string;
}

const DEFAULT_HELPER_TEXT = "We'll send an OTP to this email address";

export function AuthEmailForm({
  email,
  onEmailChange,
  onSubmit,
  isReadOnly = false,
  canContinue,
  isSubmitting,
  submitError,
  helperText = DEFAULT_HELPER_TEXT,
  testIdPrefix = 'auth-email',
}: AuthEmailFormProps) {
  return (
    <PageLayout
      className="flex flex-col flex-1 justify-between py-8"
      gridProps={{ className: 'px-5 flex-1' }}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (canContinue) onSubmit();
        }}
        className="flex flex-col gap-1"
      >
        <Input
          label="Email address"
          type="email"
          inputMode="email"
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
          value={email}
          readOnly={isReadOnly}
          onChange={(event) => onEmailChange?.(event.target.value)}
          helperText={helperText}
          data-testid={`${testIdPrefix}-input`}
        />

        <div className="mt-14 space-y-4">
          {submitError && (
            <div role="alert" className="bg-error border border-error rounded-small p-3">
              <Typography variant="body" size="small" color="error">
                {submitError}
              </Typography>
            </div>
          )}

          <Button
            type="submit"
            variant="primary"
            size="large"
            fullWidth
            disabled={!canContinue || isSubmitting}
            isLoading={isSubmitting}
            data-testid={`${testIdPrefix}-next-button`}
          >
            Next
          </Button>
        </div>
      </form>
    </PageLayout>
  );
}
